import { renewIframe } from './iframe.js';
import { setRealtimeInterval } from './runtimeInterval.js';

if (window.addEventListener) {
    window.addEventListener('message', onMessage, false);
} else {
    window.attachEvent('onmessage', onMessage);
}

function onMessage(evt) {
    if (evt.data !== 'botdefence:challenge:done' && evt.data !== '__b_d_C:done') {
        return;
    }
    if (!listeners[evt.origin]) {
        throw Error('There is no registered listener for message origin ' + evt.origin + ' data: ' + evt.data);
    }
    listeners[evt.origin](evt);
}

const listeners = Object.create(null);
window.listeners = listeners;

function registerOriginListener(origin, listener) {
    listeners[origin] = listener;
}

function noop() {}

const defaultConfig = {
    renewInterval: 5 * 60 * 1000,
    runLoop: false,
    runImmediately: false,
    timeout: 45 * 1000,
    onDone: noop,
    onStart: noop,
    onTimeout: noop
};

// {challengeEndpoint, origin, renewInterval, runLoop, runImmediately, onDone, onStart}
export function createBotDefence(cfg) {
    const config = Object.assign({}, defaultConfig, cfg);
    if (!config.challengeEndpoint) {
        throw Error('ChallengeEndpoint have to be defined.');
    }
    if (!config.origin) {
        const index = config.challengeEndpoint.indexOf('.nike.sk');
        config.origin = config.challengeEndpoint.substring(0, index + 8);
    }
    if (!config.origin) {
        throw Error('Origin have to be defined.');
    }

    const active = {};

    function doNewChallenge() {
        if (active.promise) {
            return active.promise;
        }
        active.promise = new Promise(resolve => {
            active.resolver = resolve;
        });
        config.onStart();
        active.startedOn = new Date().getTime();
        active.timeout = setTimeout(function() {
            config.onTimeout();
        }, config.timeout);
        renewIframe(config.challengeEndpoint);
        return active.promise;
    }

    registerOriginListener(config.origin, function() {
        if (active.resolver) {
            active.resolver();
        } else {
            console.warn('Invalid state: done event without any active resolver');
        }

        config.onDone(new Date().getTime() - active.startedOn);
        active.resolver = null;
        active.promise = null;
        clearTimeout(active.timeout);
    });

    let loop = null;
    function toggleLoop() {
        if (loop) {
            clearInterval(loop);
            return false;
        } else {
            loop = setRealtimeInterval(doNewChallenge, config.renewInterval);
            return true;
        }
    }
    if (config.runLoop) {
        toggleLoop();
    }
    if (config.runImmediately) {
        document.addEventListener('DOMContentLoaded', () => {
            doNewChallenge();
        });
    }

    return {
        toggleLoop: toggleLoop,
        forceChallenge: doNewChallenge,
        getStatus: () => (active.promise ? 'pending' : 'waiting')
    };
}
